import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchIndustries as fetchIndustriesApi,
  fetchProvinces as fetchProvincesApi,
} from "@/modules/shared/api/references";

export const loadIndustries = createAsyncThunk(
  "references/loadIndustries",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchIndustriesApi();
      return Array.isArray(data) ? data : [];
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Unable to load industries.";
      return rejectWithValue(message);
    }
  }
);

export const loadProvinces = createAsyncThunk(
  "references/loadProvinces",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchProvincesApi();
      return Array.isArray(data) ? data : [];
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Unable to load provinces.";
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  industries: [],
  provinces: [],
  industriesStatus: "idle",
  provincesStatus: "idle",
  industriesError: null,
  provincesError: null,
};

const referencesSlice = createSlice({
  name: "references",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadIndustries.pending, (state) => {
        state.industriesStatus = "loading";
        state.industriesError = null;
      })
      .addCase(loadIndustries.fulfilled, (state, action) => {
        state.industriesStatus = "succeeded";
        state.industries = action.payload;
      })
      .addCase(loadIndustries.rejected, (state, action) => {
        state.industriesStatus = "failed";
        state.industriesError =
          action.payload || "Unable to load industries. Please try again.";
      })
      .addCase(loadProvinces.pending, (state) => {
        state.provincesStatus = "loading";
        state.provincesError = null;
      })
      .addCase(loadProvinces.fulfilled, (state, action) => {
        state.provincesStatus = "succeeded";
        state.provinces = action.payload;
      })
      .addCase(loadProvinces.rejected, (state, action) => {
        state.provincesStatus = "failed";
        state.provincesError =
          action.payload || "Unable to load provinces. Please try again.";
      });
  },
});

export default referencesSlice.reducer;
